module.exports = __webpack_public_path__ + "static/media/dim3supreme1.5d5fefa0.pdf";